import React, {
	Component
} from 'react';
import * as Types from '@/utils/questionType'
import Footer from '../exercise/Footer';
import {reverseParseTextView} from './createRender';

class Question extends Component {
	constructor(props) {
		super(props);
		this.state = {
			visible: false
		};
	}

	componentDidMount() {
	}
	createHtml = str => ({__html: str ? str : `&nbsp;`})
	toggleAnswer = (val, e) => {
        e.stopPropagation();
        this.setState({visible: val});
    }
	render() {
		let {visible}=this.state
		const {num,children} = this.props;
		let originData = this.props.data,
			data = reverseParseTextView(originData);
		//题目检错页显示的是错的的答题答案
		if(this.props.errorAnswer) {
			originData.answer = this.props.errorAnswer
		} 
		originData.well_chosen=undefined
		originData.display_type=undefined
		let stem = JSON.parse(originData.stem)
		return(
			<div className="box-exercise" ref={'viewer'}>
                <div className="exercise-content">
                    {num!=='undefined'&&<div className="exercise-num"><span className="math_text">{`${num + 1}、`}</span></div>}
                    <div className="exercise-con">
                        <span className="form-label">内容格式：</span>
                        <div className="form-content">{originData.type_show==Types.TYPE_SHOW_AIEN_WORD_READING?'单词':'句子'}</div>
                        <span className="form-label">题干文字：</span>
                        <div className="form-content">{stem.content}</div>
                        {
                        		stem.image&&
                        		<div>
                        			<span className="form-label">图片：</span>
                        			<div className="form-content">
                        		 	<img src={stem.image}  width={300}  />
                        			</div>
                        		</div>
                        }
                         {
                        		stem.audio&&
                        		<div>
                        			<span className="form-label">音频：</span>
                        			<div className="form-content">
                        		 	<audio src={stem.audio} controls="controls"  width={300}  />
                        			</div>
                        		</div>
                        }
                    </div>

                </div>
                <div className="exercise-footer">
                		{
                        visible &&
                        <div className="footer-hide relative">
                            <div>
                                <div className="inline-block"><span style={{fontSize: 14}}>{this.props.errorAnswer?'错误答案：':'正确答案：'}</span></div>
                                <div className="inline-block" style={{width: '80%'}}>
                                    <span style={{fontSize: 14}}  dangerouslySetInnerHTML={this.createHtml(originData.answer)}/>
                                </div>
                            </div>
                            {
                                data.explain && <div>
                                    <div className="inline-block"><span style={{fontSize: 14}}>答案解析：</span></div>
                                    <div className="inline-block">
                                        <span style={{fontSize: 14}} dangerouslySetInnerHTML={this.createHtml(data.explain)}/>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    <div className="footer-show relative">
                        <Footer {...this.props} obj={originData} subject={this.props.data.subject}>
                        		{
                                this.props.canShowAnswer ?
                                    <button
                                        className="question-btn"
                                        onClick={(e) => this.toggleAnswer(!visible,e)}>
                                        {!visible ? '显示答案' : '隐藏答案'}
                                    </button> : null

                            }
                        </Footer>
                    </div>
                </div>
            </div>

		)
	}
}

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/aiEnReading/viewForView.js